"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Html", {
  enumerable: true,
  get: function get() {
    return _Html["default"];
  }
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactInteractiveComponent = require("react-interactive-component");

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _Header = _interopRequireDefault(require("./components/Header"));

var _Html = _interopRequireDefault(require("./components/Html"));

var _Nav = _interopRequireDefault(require("./components/Nav"));

var _Routes = _interopRequireDefault(require("./components/Routes"));

var variables = _interopRequireWildcard(require("./variables.js"));

var _jsxFileName = "/Users/cedricdelpoux/Development/perso/react-demo-page/src/index.js";

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  @media ", " {\n    max-width: 64rem;\n    padding: 0 6rem;\n    margin: 0 auto;\n    font-size: 1.1rem;\n  }\n\n  @media ", " {\n    padding: 0 4rem;\n    font-size: 1.1rem;\n  }\n\n  @media ", " {\n    padding: 0 1rem;\n    font-size: 1rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  * {\n    box-sizing: border-box;\n  }\n\n  body {\n    padding: 0;\n    margin: 0;\n    font-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 16px;\n    line-height: 1.5;\n    color: #606c71;\n  }\n\n  pre[class*=\"language-\"],\n  code[class*=\"language-\"] {\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject());

var Container = _styledComponents["default"].div(_templateObject2(), variables.large, variables.medium, variables.small);

var ReactDemoPage = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactDemoPage, _Component);

  function ReactDemoPage(_ref) {
    var _this;

    var editorTheme = _ref.editorTheme,
        pages = _ref.pages;
    _this = _Component.call(this) || this;

    if (_this.hasSomeDemoPages(pages)) {
      if (editorTheme) {
        (0, _reactInteractiveComponent.loadEditorTheme)(editorTheme);
      } else {
        (0, _reactInteractiveComponent.loadEditorTheme)();
      }
    }

    return _this;
  }

  var _proto = ReactDemoPage.prototype;

  _proto.hasSomeDemoPages = function hasSomeDemoPages(pages) {
    return pages.some(function (page) {
      return page.demo && page.demo.component;
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        basename = _this$props.basename,
        color = _this$props.color,
        pages = _this$props.pages,
        footer = _this$props.footer,
        header = _this$props.header;
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
      basename: basename,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react["default"].createElement(GlobalStyle, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77,
        columnNumber: 11
      }
    }), header && /*#__PURE__*/_react["default"].createElement(_Header["default"], _extends({}, header, {
      color: color,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 22
      }
    })), /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
      routes: pages,
      color: color,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 11
      }
    }), /*#__PURE__*/_react["default"].createElement(Container, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react["default"].createElement(_Routes["default"], {
      routes: pages,
      color: color,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 81,
        columnNumber: 13
      }
    })), footer && /*#__PURE__*/_react["default"].createElement(_Footer["default"], _extends({}, footer, {
      color: color,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 22
      }
    }))));
  };

  return ReactDemoPage;
}(_react.Component);

ReactDemoPage.propTypes = process.env.NODE_ENV !== "production" ? {
  basename: _propTypes["default"].string,
  header: _propTypes["default"].shape({
    buttons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      url: _propTypes["default"].string.isRequired
    })),
    title: _propTypes["default"].string.isRequired
  }),
  footer: _propTypes["default"].shape({
    author: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      email: _propTypes["default"].string.isRequired
    })
  }),
  color: _propTypes["default"].string,
  editorTheme: _propTypes["default"].string,
  pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    component: _propTypes["default"].element,
    demo: _propTypes["default"].shape({
      component: _propTypes["default"].element.isRequired
    }),
    html: _propTypes["default"].string,
    label: _propTypes["default"].string.isRequired,
    path: _propTypes["default"].string.isRequired
  })).isRequired
} : {};
ReactDemoPage.defaultProps = {
  basename: null,
  color: variables.mainColor,
  footer: null,
  header: null
};
var _default = ReactDemoPage;
exports["default"] = _default;